import React from "react";
import { Mail, Phone } from "lucide-react";
import { SOCIAL_LINKS } from "@/components/site/socials";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative pt-12 md:pt-16 pb-14 md:pb-20 px-6 md:px-12 bg-vintage-bg"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-vintage-rust mb-4">
            / / Bookings, Press &amp; General Inquiries
          </p>
          <h2 className="font-heading text-5xl md:text-7xl uppercase text-vintage-gold tracking-wide leading-none">
            Get In Touch
          </h2>
          <p className="font-subheading italic text-vintage-cream/70 text-lg md:text-xl mt-4 max-w-xl mx-auto">
            For tour bookings, press inquiries, or just to say hello — drop a
            line or give a call. We read every message.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <a
            href="mailto:ojr.lagarhus@gmail.com"
            data-testid="contact-email-card"
            className="group block bg-vintage-bg2 border border-vintage-cream/10 hover:border-vintage-rust/60 transition-colors p-8"
          >
            <div className="flex items-center gap-3 mb-5">
              <Mail className="text-vintage-rust" size={22} />
              <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-cream/50">
                Email
              </span>
            </div>
            <p className="font-subheading italic text-vintage-cream/70 text-sm mb-2">
              Management · Press · General
            </p>
            <p className="font-heading text-xl md:text-2xl text-vintage-cream group-hover:text-vintage-rust transition-colors tracking-wide break-all">
              ojr.lagarhus@gmail.com
            </p>
          </a>

          <a
            href="tel:+4794173045"
            data-testid="contact-phone-card"
            className="group block bg-vintage-bg2 border border-vintage-cream/10 hover:border-vintage-rust/60 transition-colors p-8"
          >
            <div className="flex items-center gap-3 mb-5">
              <Phone className="text-vintage-rust" size={22} />
              <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-cream/50">
                Phone
              </span>
            </div>
            <p className="font-subheading italic text-vintage-cream/70 text-sm mb-2">
              Norway · CET timezone
            </p>
            <p className="font-heading text-xl md:text-2xl text-vintage-cream group-hover:text-vintage-rust transition-colors tracking-wide">
              +47 941 73 045
            </p>
          </a>

          <a
            href="mailto:info@bbkbooking.com"
            data-testid="contact-eu-booking-card"
            className="group block bg-vintage-bg2 border border-vintage-gold/30 hover:border-vintage-gold transition-colors p-8 relative"
          >
            <span className="absolute -top-3 left-6 bg-vintage-gold text-vintage-bg font-mono text-[10px] tracking-[0.3em] uppercase px-3 py-1">
              EU Bookings
            </span>
            <div className="flex items-center gap-3 mb-5">
              <Mail className="text-vintage-gold" size={22} />
              <span className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-cream/50">
                BBK Booking
              </span>
            </div>
            <p className="font-subheading italic text-vintage-cream/70 text-sm mb-2">
              European tour booking agency
            </p>
            <p className="font-heading text-xl md:text-2xl text-vintage-cream group-hover:text-vintage-gold transition-colors tracking-wide break-all">
              info@bbkbooking.com
            </p>
          </a>
        </div>

        {/* Socials strip */}
        <div className="mt-20 md:mt-24 text-center">
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-cream/50 mb-5">
            Or find us on
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            {SOCIAL_LINKS.map((s, i) => {
              const Icon = s.icon;
              const isPatreon = s.label === "Patreon";
              return (
                <a
                  key={s.label}
                  href={s.href}
                  data-testid={`contact-social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                  className={`inline-flex items-center justify-center border border-vintage-cream/20 hover:border-vintage-rust hover:text-vintage-rust transition-colors ${
                    isPatreon
                      ? "px-4 h-12 font-mono text-xs tracking-[0.25em] uppercase"
                      : "w-12 h-12"
                  }`}
                >
                  {isPatreon ? "Patreon" : <Icon className="w-5 h-5" />}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
